export const getObjectName = (object: any) => {
  if (typeof object === 'string') return object
  if (typeof object === 'object' && !!object.name) return object.name
  return ''
}
